import { formatTime } from '../utils/formatTime'
import styles from './ResumePrompt.module.css'

interface Props {
  time: number | null
  onResume: () => void
  onDismiss: () => void
}

export function ResumePrompt({ time, onResume, onDismiss }: Props) {
  if (time == null) return null
  return (
    <div className={styles.wrap}>
      <p>Resume from {formatTime(time)}?</p>
      <div className={styles.actions}>
        <button type="button" className={styles.primary} onClick={onResume}>
          Resume
        </button>
        <button type="button" onClick={onDismiss}>
          Start over
        </button>
      </div>
    </div>
  )
}
